export default {"src":"/_next/static/media/slow.1f5fe5a6.svg","height":300,"width":1020,"blurWidth":0,"blurHeight":0};